(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-pro"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.faq-pro').forEach(function(section) {
      var toggleBtns = section.querySelectorAll('[data-faq-toggle]');
      var items = section.querySelectorAll('.faq-pro__item');

      toggleBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var index = this.getAttribute('data-faq-toggle');

          toggleBtns.forEach(function(b) { b.classList.remove('faq-pro__toggle-btn--active'); });
          this.classList.add('faq-pro__toggle-btn--active');

          items.forEach(function(item) {
            if (item.getAttribute('data-faq-group') === index) {
              item.classList.add('faq-pro__item--visible');
            } else {
              item.classList.remove('faq-pro__item--visible');
              item.removeAttribute('open');
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-pro-1"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var toggles = document.querySelectorAll('.footer-pro-1__toggle');
    toggles.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var col = btn.closest('.footer-pro-1__menu-col');
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !expanded);
        col.classList.toggle('is-open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isTransparent = this.classList.contains('header-wrapper--transparent');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.isTransparent) this.classList.add('scrolled-past-transparent');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.isTransparent) this.classList.add('scrolled-past-transparent');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (this.isTransparent) this.classList.remove('scrolled-past-transparent');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.isTransparent) this.classList.add('scrolled-past-transparent');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.isTransparent) this.classList.add('scrolled-past-transparent');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.isTransparent) this.classList.remove('scrolled-past-transparent');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-pro"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var heroEls = document.querySelectorAll('.hero-pro--parallax');
    if (!heroEls.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.dataset.heroVisible = 'true';
        } else {
          entry.target.dataset.heroVisible = 'false';
        }
      });
    }, { threshold: 0 });

    heroEls.forEach(function(hero) {
      observer.observe(hero);
    });

    function onScroll() {
      heroEls.forEach(function(hero) {
        if (hero.dataset.heroVisible !== 'true') return;
        var media = hero.querySelector('.hero-pro__media--parallax');
        if (!media) return;
        var rect = hero.getBoundingClientRect();
        var scrollPercent = -rect.top / (rect.height + window.innerHeight);
        var translate = scrollPercent * 40;
        media.style.transform = 'translate3d(0, ' + translate + '%, 0)';
      });
      requestAnimationFrame(arguments.callee);
    }

    requestAnimationFrame(onScroll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-pro"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sliders = document.querySelectorAll('[data-testimonials-slider]');
    if (!sliders.length) return;

    sliders.forEach(function(slider) {
      var track = slider.querySelector('[data-testimonials-track]');
      var prevBtn = slider.querySelector('[data-testimonials-prev]');
      var nextBtn = slider.querySelector('[data-testimonials-next]');
      var progress = slider.querySelector('[data-testimonials-progress]');

      if (!track) return;

      function updateControls() {
        var scrollLeft = track.scrollLeft;
        var maxScroll = track.scrollWidth - track.clientWidth;

        if (prevBtn) prevBtn.disabled = scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = scrollLeft >= maxScroll - 2;

        if (progress) {
          var pct = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
          progress.style.width = Math.max(20, pct) + '%';
          progress.style.marginLeft = (pct / 100) * (100 - Math.max(20, pct)) + '%';
        }
      }

      function scrollBy(dir) {
        var card = track.querySelector('.testimonials-pro__card');
        if (!card) return;
        var distance = card.offsetWidth + parseInt(getComputedStyle(track).gap || 0);
        track.scrollBy({ left: dir * distance, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { scrollBy(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { scrollBy(1); });
      track.addEventListener('scroll', updateControls, { passive: true });

      updateControls();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-section-2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('[data-section-id]');
    sections.forEach(function(section) {
      if (!section.id || !section.id.startsWith('VS2-')) return;

      var autoClose = section.getAttribute('data-auto-close') === 'true';
      var tabs = section.querySelectorAll('[data-vs2-tab]');

      tabs.forEach(function(tab) {
        tab.addEventListener('toggle', function() {
          if (autoClose && tab.open) {
            tabs.forEach(function(other) {
              if (other !== tab && other.open) {
                other.removeAttribute('open');
              }
            });
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
